const imageToBase64 = async (
  input: File | string | null | undefined,
): Promise<string> => {
  if (!input) {
    return "";
  }

  // File to base64
  if (input instanceof File) {
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(input);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => resolve("");
    });
  }

  if (typeof input === "string") {
    // If already base64
    if (input.startsWith("data:image/")) {
      return input;
    }

    // If it's a URL, return empty string
    try {
      const url = new URL(input);
      if (url.protocol === "http:" || url.protocol === "https:") {
        return "";
      }
    } catch {
      // Not a valid URL, fall through
    }
  }

  return "";
};

export default imageToBase64;
